<template>
  <div>
    <Drawer title="站点详情" width="900" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">
      <Row>
        <Col span="12" class="info-item">
          <span>站点ID:</span>
          <span>{{baseInfo.station_id}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>站点名称:</span>
          <span>{{baseInfo.gas_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>站点类型:</span>
          <span>{{baseInfo.station_type_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>省市区:</span>
          <span>{{baseInfo.province_name}}/{{baseInfo.city_name}}/{{baseInfo.county_name}} </span>
        </Col>
        <Col span="24" class="info-item">
          <span>站点地址:</span>
          <span>{{baseInfo.gas_address}}</span>
        </Col>
        <!--<Col span="12" class="info-item">
          <span>营业时间:</span>
          <span>{{baseInfo.work_start_time}} - {{baseInfo.work_end_time}}</span>
        </Col>-->
        <Col span="12" class="info-item" >
          <span>推荐上级:</span>
          <span v-if="baseInfo.parent_info">{{baseInfo.parent_info.user_id}} {{baseInfo.parent_info.nick_name}} {{baseInfo.parent_info.mobile}}</span>
          <span v-else></span>
        </Col>
        <Col span="12" class="info-item" >
          <span>合伙人:</span>
          <span v-if="baseInfo.agent_info">{{baseInfo.agent_info.user_id}} {{baseInfo.agent_info.nick_name}} {{baseInfo.agent_info.mobile}}</span>
          <span v-else></span>
        </Col>
        <Col span="12" class="info-item">
          <span>联系人:</span>
          <span>{{baseInfo.contact_user}} {{baseInfo.contact_mobile}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>注册时间:</span>
          <span>{{baseInfo.create_time}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>状态:</span>
          <span>
            {{baseInfo.gas_status_name}}

          <template v-if="baseInfo.gas_status === 1 || baseInfo.gas_status === -1">
             <i-switch v-model="gas_status" size="large" true-color="#13ce66" false-color="#ff4949" @on-change="changeStatus" true-value="1" false-value="-1">
              <span slot="open">正常</span>
              <span slot="close">禁用</span>
            </i-switch>
          </template>
          <template v-else-if="baseInfo.gas_status === 5">
            <Button size="small" type="primary" @click="verify('pass')">审核通过</Button>
            <Button size="small" type="error" @click="verify('deny')">审核不通过</Button>
          </template>
          </span>
        </Col>


        <Col span="24" class="info-item" v-if="baseInfo.type===1">
          <span style="line-height: 40px;vertical-align: bottom;">站点LOGO:</span>
          <span v-if="baseInfo.gas_logo_big">
              <viewer :images="[baseInfo.gas_logo_big]">
                <img :key="baseInfo.gas_logo_big" :src="baseInfo.gas_logo_big" style="width: 30px;height: 30px;margin: 5px">
              </viewer>
            </span>
          <span v-else>暂无图片</span>
        </Col>

      </Row>

      <Row>
        <Col span="12" class="info-item">
          <span>电话抽成:</span>
          <span>
            <Input v-model="baseInfo.commission_mobile" style="width: 30%;margin-right: 5px"></Input>
            <Button type="primary" @click="setCommissionMobile">修改</Button>
          </span>
        </Col>

      </Row>

      <Tabs>
        <TabPane label="订单列表">
          <pageTable tabelRef="orderTable"
                     :tableTitle="orderTableColumn"
                     :searchData="{}"
                     :tableHeight="300"
                     :defaultSearchParam="{station_id:this.station_id}"
                     tableApi="admin/order/getOrderByStation"
          >
          </pageTable>
        </TabPane>

      </Tabs>



    </Drawer>
  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "edit",
    components:{pageTable},
    props:{
      showEdit:{
        type:Boolean,
        default: false
      },
      station_id:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        baseInfo:{},
        gas_status:'1',
        orderTableColumn:[
          {title:'ID',key:'order_id',align:'center'},
          {title:'总金额',key:'total_price',align:'center'},
          {title:'抽佣',key:'plate_percentage',align:'center'},
          {title:'应收金额',key:'supplier_income',align:'center'},
          {title:'下单时间',key:'create_time',align:'center',width:140},
        ],
      }
    },
    methods:{
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/gas/getDetailInfo',{station_id:this.station_id});
        this.$commonFun.dealApiResult(res,()=>{
          this.baseInfo = res.data
          this.gas_status = res.data.gas_status
        })
      },
      cancelEdit(){
         this.$emit('cancel-edit')
      },
      changeStatus(status){
        this.$commonFun.postProxy('admin/gas/changeStatus',{station_id:this.station_id,status}).then(res=>{
          this.$commonFun.dealApiResult(res,()=>{
            this.$commonFun.successTip(res.msg,()=>{
              this.getInfo();
            })
          })
        })
      },
      verify(status){
        this.$commonFun.postProxy('admin/gas/verify',{station_id:this.station_id,status}).then(res=>{
          this.$commonFun.dealApiResult(res,()=>{
            this.$commonFun.successTip(res.msg,()=>{
              this.getInfo();
            })
          })
        })
      },
      setCommissionMobile(){
        this.$commonFun.postProxy('admin/gas/setCommissionMobile',{station_id:this.station_id,commission:this.baseInfo.commission_mobile}).then(res=>{
          this.$commonFun.dealApiResult(res,()=>{
            this.$commonFun.successTip(res.msg,()=>{
              this.getInfo();
            })
          })
        })
      },

    },
    mounted() {
        this.getInfo()
    },
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>
